import { Anchor, Table } from "@mantine/core";
import { getFullName } from "../../helpers/stringHelper";
import type { UserType } from "../../models/user";

type UserViewProps<T extends UserType> = {
  userType: T;
  colSpan?: number;
};

export function UserView<T extends UserType>({ userType, colSpan = 1 }: UserViewProps<T>) {
  return (
    <>
      <Table.Tr>
        <Table.Th>Name</Table.Th>
        <Table.Td colSpan={colSpan}>{`${userType.salutation} ${getFullName(userType)}`}</Table.Td>
      </Table.Tr>
      <Table.Tr>
        <Table.Th>E-Mail</Table.Th>
        <Table.Td colSpan={colSpan}>
          <Anchor href={`mailto:${userType.user.email}`}>{userType.user.email}</Anchor>
        </Table.Td>
      </Table.Tr>
    </>
  );
}
